// extracted by mini-css-extract-plugin
module.exports = {"navigation":"navigation_navigation__unRcd"};